'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = ListSubheader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('ListSubheader', function (theme) {
  var typography = theme.typography;


  return {
    root: Object.assign({
      boxSizing: 'border-box',
      paddingTop: typography.rhythmByUnit(3.5),
      paddingLeft: typography.rhythmByUnit(2)
    }, typography.menugroup),
    primary: typography.primary,
    secondary: typography.secondary,
    accent: typography.highlight,
    error: typography.error,
    disabled: typography.disabled,
    inset: {
      paddingLeft: typography.rhythmByUnit(9)
    }
  };
});

ListSubheader.propTypes = {
  /**
   * The content of the ListSubheader.
   */
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the ListSubheader will be indented.
   */
  inset: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's primary color.
   */
  primary: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * If true, will use the theme's accent color.
   */
  accent: _PropTypes2['default'].bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the text will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If false, the ripple effect will be disabled.
   */
  ripple: _PropTypes2['default'].bool
};

ListSubheader.defaultProps = {
  inset: false,
  primary: false,
  secondary: false,
  accent: false,
  disabled: false,
  error: false
};

ListSubheader.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

function ListSubheader(props, context) {
  var _classNames;

  var classNameProp = props.className,
      primary = props.primary,
      secondary = props.secondary,
      accent = props.accent,
      disabled = props.disabled,
      error = props.error,
      inset = props.inset,
      children = props.children,
      other = _objectWithoutProperties(props, ['className', 'primary', 'secondary', 'accent', 'disabled', 'error', 'inset', 'children']);

  var classes = context.styleManager.render(styleSheet);
  var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.primary, primary && !(secondary || accent || error || disabled)), _defineProperty(_classNames, classes.secondary, secondary && !(accent || error || disabled)), _defineProperty(_classNames, classes.accent, accent && !(error || disabled)), _defineProperty(_classNames, classes.error, error && !disabled), _defineProperty(_classNames, classes.disabled, disabled), _defineProperty(_classNames, classes.inset, inset), _classNames), classNameProp);

  return _react2['default'].createElement(
    'div',
    _extends({ className: className }, other),
    children
  );
}

ListSubheader.displayName = 'ListSubheader';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/ListSubheader.js
// module id = 640
// module chunks = 32